import { render, staticRenderFns } from "./roles-list.vue?vue&type=template&id=f2b6cee0&scoped=true&"
import script from "./roles-list.vue?vue&type=script&lang=js&"
export * from "./roles-list.vue?vue&type=script&lang=js&"
import style0 from "./roles-list.vue?vue&type=style&index=0&id=f2b6cee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b6cee0",
  null
  
)

export default component.exports